/**
 * Deployment configuration, injected at build time from terraform outputs by
 * `scripts/write-env.mjs`. Nothing here is secret - a Cognito pool id and a
 * public app client id are meant to be in the browser - but they do change
 * whenever the environment is rebuilt, so they are never hard-coded.
 */

function required(name: string, value: string | undefined): string {
  if (value === undefined || value === "") {
    throw new Error(
      `Missing ${name}. Run "npm run config --workspace @so/web" to regenerate .env.local from terraform outputs.`,
    );
  }
  return value;
}

export const config = {
  userPoolId: required("VITE_USER_POOL_ID", import.meta.env.VITE_USER_POOL_ID),
  userPoolClientId: required("VITE_USER_POOL_CLIENT_ID", import.meta.env.VITE_USER_POOL_CLIENT_ID),
  apiEndpoint: required("VITE_API_ENDPOINT", import.meta.env.VITE_API_ENDPOINT).replace(/\/$/, ""),
} as const;
